'use client';

import { useAtomValue } from 'jotai';
import { ITechnology } from '@sapientpro/sapientpro-data-models';
import { Theme, theme } from '../../../../store/theme';
import styles from './CaseSidebar.module.scss';
import Img from '../../../../components/Img';

const TechnologyItem = ({ technology }: { technology: ITechnology }) => {
  const appTheme = useAtomValue(theme);

  const darkImage = technology.image.dark;
  const lightImage = technology.image.light;

  const image = appTheme === Theme.DARK ? darkImage : lightImage;

  return (
    <div
      key={technology.id}
      className={styles.technologyItem}
    >
      <div className={styles.technologyIconWrapper}>
        <Img
          src={image?.url}
          width={image?.width}
          height={image?.height}
          alt={image?.alternativeText || technology.name}
          className={styles.technologyIcon}
        />
      </div>
      <p className={styles.technologyName}>{technology.name}</p>
    </div>
  );
};

export default TechnologyItem;
